import { createStore, ObservableMap } from "@stencil/store";
import { h } from "@stencil/core";

export interface AuthStoreState {
    isAuthenticating: boolean;
    authError: string | null;
}

export type AuthStore = ObservableMap<AuthStoreState>;

export const createAuthStore = () => {
    const store = createStore<AuthStoreState>({
        isAuthenticating: false,
        authError: null
    });

    return store;
};

export const SilentAuth = ({ disabled, config, authStore, apiClient }) => {
    if (disabled || config.useMockData) return;

    const onAuth = (e: CustomEvent): void => {
        authStore.state.authError = e.detail.error;
        if (authStore.state.authError !== null) {
            authStore.state.isAuthenticating = false;
            return;
        }
        apiClient
            .requestTbdbToken()
            .then((token) => {
                if (!token) {
                    throw new Error("No TBDB token received");
                }
            })
            .catch((error) => {
                // CORS errors are blocked by the browser and can't be shown to the user directly
                if (error.name === "TypeError" && error.message === "Failed to fetch") {
                    authStore.state.authError = "CORS error occurred requesting the TBDB token";
                    return;
                }
                authStore.state.authError = error || "An error occurred requesting the TBDB token";
            })
            .finally(() => {
                authStore.state.isAuthenticating = false;
            });
    };

    return (
        <ux-u-silent-auth
            client-id={config.authClientId}
            issuer={config.authIssuer}
            onUxAuth={(e: CustomEvent) => onAuth(e)}
        ></ux-u-silent-auth>
    );
};
